import React, { useEffect, useState } from "react";
import { Link, useHistory } from "react-router-dom";
import { CSVLink } from "react-csv";
// components
import PageHeader from "components/BreadCrumb";
import CustomPagination from "components/CustomPagination ";

// hooks
import { useTable } from "hooks/custom/useTable";
import { useDeleteCampus, useGetCampuses } from "hooks/api/campus";

const Campus = () => {
  const history = useHistory();

  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(true);
  const { page, rowsPerPage, handleChangePage, handleChangeRowsPerPage } =
    useTable();

  const { data: campuses, refetch } = useGetCampuses();
  const deleteCampus = useDeleteCampus(refetch);

  useEffect(() => {
    if (campuses?.data) {
      setRows(campuses?.data);
      setLoading(false);
    }
  }, [campuses?.data]);

  return (
    <div className="container-fluid">
      <PageHeader HeaderText="Campuses" Breadcrumb={[{ name: "Campuses" }]} />

      <div className="card">
        <div
          className="header"
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          <h2>All Campuses</h2>
          <div
            style={{
              display: "flex",
              gap: "10px",
              alignItems: "center",
            }}
          >
            <CSVLink filename={"all-campus.csv"} data={rows}>
              {" "}
              <button type="button" className="btn btn-primary">
                <span className="mx-1">Export Campuses</span>
                <i className="fa fa-download"></i>
              </button>
            </CSVLink>

            <Link to="/campuses/create">
              <button
                type="button"
                className="btn btn-success"
                title="Create User"
              >
                <span className="sr-only">Create Campus</span>
                <i className="fa fa-plus mr-1"></i> <span>Create Campus</span>
              </button>
            </Link>
          </div>
        </div>

        <div className="body table-responsive">
          <table className="table table-bordered">
            <thead>
              <tr>
                <th>Code</th>
                <th>Name</th>
                <th>School</th>
                <th>Region</th>
                <th style={{ textAlign: "end" }}>ACTIONS</th>
              </tr>
            </thead>
            <tbody>
              {loading ? (
                <tr>
                  <td></td>
                  <td></td>
                  <td
                    style={{
                      textAlign: "center",
                      height: "30vh",
                      width: "100%",
                    }}
                    className="visible-lg"
                  >
                    <i className="fa fa-spinner fa-4x fa-spin"></i>
                  </td>
                  <td></td>
                  <td></td>
                </tr>
              ) : (
                <>
                  {" "}
                  {rows?.length > 0 ? (
                    rows
                      ?.slice(
                        page * rowsPerPage,
                        page * rowsPerPage + rowsPerPage
                      )
                      ?.map((row) => (
                        <tr key={row.id}>
                          <td>{row.code}</td>
                          <th scope="row">{row.name}</th>
                          <td>{row.users_group_name}</td>
                          <td>{row.region_name}</td>
                          <td
                            style={{
                              display: "flex",
                              justifyContent: "flex-end",
                            }}
                          >
                            <button
                              type="button"
                              className="btn btn-danger"
                              title="Delete"
                              onClick={() => deleteCampus.mutate(row.id)}
                            >
                              <span className="sr-only">Delete</span>
                              <i className="fa fa-trash-o"></i>
                            </button>

                            <button
                              type="button"
                              className="btn btn-warning mr-1"
                              title="Edit"
                              onClick={() =>
                                history.push(`/campuses/edit/${row.id}`)
                              }
                            >
                              <span className="sr-only">Edit</span>
                              <i className="fa fa-edit"></i>
                            </button>
                          </td>
                        </tr>
                      ))
                  ) : (
                    <tr>
                      <td></td>
                      <td></td>
                      <td
                        style={{
                          textAlign: "center",
                          height: "30vh",
                          fontSize: "1.5rem",
                          width: "100%",
                        }}
                      >
                        Oops! No data found
                      </td>
                      <td></td>
                      <td></td>
                    </tr>
                  )}
                </>
              )}
            </tbody>
          </table>
        </div>

        <div className="body" style={{ paddingTop: 0, paddingBottom: 0 }}>
          <CustomPagination
            count={rows.length}
            page={page}
            rowsPerPage={rowsPerPage}
            onPageChange={handleChangePage}
            onRowsPerPageChange={handleChangeRowsPerPage}
          />
        </div>
      </div>
    </div>
  );
};

export default Campus;
